import { Link, useNavigate } from "react-router-dom"
import IMAGES from "../../../../assets/images/images"
import styles from "./mapwidgets.module.css"
import { connect } from "react-redux"
import { useEffect } from "react"
import { isWidgetPresent } from "../../../../utils/arrayUtils"
import Shimmer from "../../../../components/shimmer/Shimmer"
import { getPopsCount } from "../../../../redux/actions/home/home.action"
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView"
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip"
import { WIDGET_NAME } from "../../../../utils/constants/homeConstants"
const Mapwidgets = ({action,popsCountData,isHovered,...props}) => {
    const navigate = useNavigate()

    const gotoDetail = () => {
      if(Object.keys(popsCountData).length !== 0){
        switch (action) {
          case WIDGET_NAME.WORLDWIDE_POPS_COUNT_WIDGET:
              return "/map";
          default:
              return "#";
        }
      }
    }

    useEffect(()=>{
      // isWidgetPresent(props?.myRights?.widgetDetails,action)&&props?.getPopsCount(action)
      props?.getPopsCount(action) 
    },[])
    const retry = () =>{
      props?.getPopsCount(action) 
    }
    return (
      props?.isLoading?<Shimmer /> :
      <Link to={gotoDetail(action)} target="_blank" rel="noopener noreferrer"className={`${props?.isFullWidth&&styles.worldmap} ${styles.removelink}`}>
        <div className={`${styles.mapwidget} ${props?.isFullWidth&&styles.partone}`}>
            {props?.isFullWidth?<></>:
            <div className={styles.popheader}>
              <div className={`${styles.mapheader} ${isHovered ? styles.mapheaderHover : ""}`}>Worldwide Vodafone PoPs</div>
              {Object.keys(popsCountData).length === 0 ?
                <div className={styles.retryparent} onClick={retry}> <div className={styles.retryicon}></div><div className={styles.poplink}>Refresh</div></div>:
                <div className={styles.parent}><div className={styles.rightarrow}></div></div>}
            </div>}
            {!props?.isFullWidth && Object.keys(popsCountData).length === 0?<div className={styles.emptydiv}><EmptyDataView/></div>:<>
            <div className={`${styles.popcard}`}>
                <div className={`${styles.popcount} ${isHovered ? styles.popcountHover : ""}`}>{popsCountData?.worldWideCount}{` ${props?.isFullWidth?"Vodafone":""}`} PoPs</div>
                <img src={`${IMAGES.popimage}`} className={`${styles.popimage} ${isHovered ? styles.popimageHover : ""} ${props?.isFullWidth&&styles.visivility}`} />
            </div>
            {/* {props?.isFullWidth&&<div className={styles.poplink} onClick={()=>gotoDetail()}>View in Map</div>} */}
            </>}
        </div>
        {props?.isFullWidth&&<div className={styles.parttwo}></div>}
      </Link>
    )
}
const mapStateToProps = (state) => {
  return {
    popsCountData:state?.dashBoardCounts?.popsCount?.data,
    isLoading:state?.dashBoardCounts?.popsCount?.isLoading,
    myRights : state.myRights.myRights
  }
}
const mapDispatchToProps = (dispatch)=>{
  return {
    getPopsCount: (action) => {
        return dispatch(getPopsCount(action))
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Mapwidgets)